<!-- Image Cropper Modal -->
@if (isVisible) {
  <div class="cropper-modal">
    <div class="cropper-modal__overlay" (click)="!isUploading && close()"></div>
    <div class="cropper-modal__content">
      <div class="cropper-modal__header">
        <h3 class="cropper-modal__title">{{ title }}</h3>
        <button
          type="button"
          class="cropper-modal__close"
          (click)="close()"
          [disabled]="isUploading"
          [attr.aria-label]="'common.close' | translateLang">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
        </button>
      </div>

      <div class="cropper-modal__body"
           (mousemove)="onCanvasMouseMove($event)"
           (mouseup)="onCanvasMouseUp($event)"
           (touchmove)="onCanvasTouchMove($event)"
           (touchend)="onCanvasTouchEnd($event)">
        <div class="cropper-container">
          <canvas
            #cropperCanvas
            class="cropper-canvas"
            width="400"
            height="400"
            [style.cursor]="currentCursor"
            (mousedown)="onCanvasMouseDown($event)"
            (mousemove)="onCanvasMouseHover($event)"
            (touchstart)="onCanvasTouchStart($event)"
            (load)="initCropperCanvas()"
          ></canvas>
        </div>
        <p class="cropper-hint">{{ hintText }}</p>
      </div>

      <div class="cropper-modal__footer">
        <button
          type="button"
          class="cropper-button cropper-button--secondary"
          (click)="close()"
          [disabled]="isUploading">
          {{ 'common.cancel' | translateLang }}
        </button>
        <button
          type="button"
          class="cropper-button cropper-button--primary"
          (click)="applyCrop()"
          [disabled]="isUploading">
          @if (isUploading) {
            <span class="cropper-button__spinner"></span>
            <span>{{ uploadingText }}</span>
          } @else {
            <span>{{ 'common.save' | translateLang }}</span>
          }
        </button>
      </div>
    </div>
  </div>
}
